/* eslint-disable react/jsx-props-no-spreading */

import React, { FC, ChangeEvent, FocusEvent } from 'react';
import { Field } from 'formik';
import { Input } from 'reactstrap';
import get from 'lodash/get';

import useFormContext from '@hooks/useFormContext';

import { BaseFormComponentProps } from '@models/forms';

import { renderFormError } from '@utils/forms';

export interface BaseCheckProps {
    disabled?: boolean;
    error?: boolean;
    invalid?: boolean;
    focused?: boolean;
    name?: string;
    onBlur?(e: FocusEvent<HTMLTextAreaElement>): void;
    onChange?(e: ChangeEvent<HTMLTextAreaElement>): void;
    value: string;
}

type ComponentProps = BaseFormComponentProps<BaseCheckProps>;

const FormCheck: FC<ComponentProps> = ({
    hideErrorBlock = false,
    hideErrorText = false,
    label,
    ...baseCheckProps
}) => {
    const { name } = baseCheckProps;
    const { errors, touched } = useFormContext();

    const error = !!get(errors, name) && !!get(touched, name);

    return (
        <div className="form-row">
            <div className="form-group form-check-inline">
                <Field {...baseCheckProps} as={Input} type="checkbox" className="" invalid={error} /> {label}
                {hideErrorBlock ? null : renderFormError(name, hideErrorText)}
            </div>
        </div>
    );
};

export default FormCheck;
